module.exports = __webpack_public_path__ + "images/paper-add.1789545008192.png";